export const PROFILE_FIELD_OPTAVIA_ID = 'PROFILE_FIELD_OPTAVIA_ID';
export const PROFILE_FIELD_COACH = 'PROFILE_FIELD_COACH';
export const PROFILE_FIELD_BUSINESS_COACH = 'PROFILE_FIELD_BUSINESS_COACH';
export const PROFILE_FIELD_HIGHEST_RANK = 'PROFILE_FIELD_HIGHEST_RANK';
export const PROFILE_FIELD_CERTIFIED = 'PROFILE_FIELD_CERTIFIED';
export const PROFILE_FIELD_RENEWAL_EXPIRY = 'PROFILE_FIELD_RENEWAL_EXPIRY';
export const PROFILE_FIELD_ACTIVATION_DATE = 'PROFILE_FIELD_ACTIVATION_DATE';
